import { useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { Button } from '~/components/Button'
import { Modal } from '~/components/Modal'
import { evaluationAtom } from '~/modules/evalutation/data'
import { patchEvaluationAtom } from '~/modules/evalutation/services'
import { useAtom } from '~/observers/jotai'
import { schedulerRoute } from '~/routes/routes'
import { EvaluationRouteParams } from '~/routes/types'

export const PromptModal: React.FC = () => {
  const navigate = useNavigate()
  const [evaluation] = useAtom(evaluationAtom)

  const { evaluation_id, student_id } = useParams<EvaluationRouteParams>()

  const handleNavigateOut = useCallback(() => {
    if (student_id && evaluation_id) {
      navigate(
        `${schedulerRoute
          .replace(':student_id', student_id)
          .replace(':evaluation_id', evaluation_id)}`,
        { replace: true },
      )
    }
  }, [navigate, student_id, evaluation_id])

  const handleCloseModal = useCallback(() => {
    patchEvaluationAtom({ hasAerobicPrescription: true })
  }, [])

  return (
    <Modal visible={!evaluation?.hasAerobicPrescription}>
      <div className='flex flex-col gap-5'>
        <h1 className='text-lg'>Deseja prescrição aeróbica?</h1>
        <div className='flex gap-4 self-end'>
          <Button mode='outlined' className='w-28' onClick={handleNavigateOut}>
            Não
          </Button>
          <Button className='w-28' onClick={handleCloseModal}>
            Sim
          </Button>
        </div>
      </div>
    </Modal>
  )
}
